"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.accountRoutes = void 0;
const component_1 = require("@front/pages/account/upgrade/component");
exports.accountRoutes = [
    {
        path: '/account/upgrade',
        name: 'account.upgrade.title'.t(),
        component: component_1.AccountUpgrade,
        requiresAuth: true
    }
];
